<template>
  <!-- inset height="70" -->
  <v-footer height="50"  dark padless app  inset class="bg-blur d-flex justify-center align-center">
    <!-- <v-card class="flex" color="#078fc3" flat tile>
      <v-card-text class="py-2 white--text text-center">
        <h3>Powered by DCM © 2021</h3>
      </v-card-text>
    </v-card> -->
    <!-- 
     <router-link  color="white" to="/account-detail">Contact</router-link> -->

     <!-- style="background: linear-gradient(135deg, #ffffff, #ffffff, #ffffff, #ffffff, #9EE0F8, #9EE0F8, #ffffff);" -->
    <v-card class="flex bg-blur p-0 pa-0" flat tile style="background-color: #078fc3;">
      <v-card-text  class="footer-wrapper p-0 pa-0">
        <!-- <v-btn
          text
          rounded
          class="my-2"
          href="https://www.dcm.co.th/wp-content/uploads/2021/12/DCMPrivacyPolicy.pdf"
          target="_blank"
          >{{ this.lg_footer.privacy_policy }}</v-btn
        > -->
      </v-card-text>

      <!-- <v-card-text class="py-0 black--text text-center p-0 pa-0" >
       <h4>© Copyright {{ new Date().getFullYear() }} Digital Corporate Management Co. Ltd. All Rights Reserved</h4>
      </v-card-text> -->
    </v-card>
  </v-footer>
</template>

<script>

export default {
  name: "Footer",
  data() {
    return {
      title: "Footer",
      version: "1.0",
      acc_plan: "FREE",
      date_exire: "",
      checklanguage:"",
      checklogin:false,
    };
  },
   async mounted() {
    // this.checklogin = api.isLoggedIn();
  },
    computed: {
    },
  methods: {
  },
  async beforeCreate() {
  },
};
</script>
<style type="text/css">
@media only screen and (max-width: 600px) {
  .v-btn:not(.v-btn--round).v-size--default {
    height: 20px;
  }
}
.footer-wrapper {
    /* background-color: #FAFAFA; */
    /* background: linear-gradient(135deg, #ffffff, #ffffff, #ffffff, #ffffff, #9EE0F8, #9EE0F8, #ffffff); */
}

.bg-blur{
    /* position: fixed; */
    /* position: absolute; */
  background-color: #FAFAFA!important;
  /* background-color: rgba(255, 255, 255, 0) !important; */
  backdrop-filter: blur(0px) !important;
  -webkit-backdrop-filter: blur(0px) !important; 
  /* z-index: 1000 !important;  */
}
</style>
